module.exports = __webpack_public_path__ + "is.c79fa464538603642837.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/node_modules/flag-icon-css/flags/1x1/is.svg
// module id = ../../../../flag-icon-css/flags/1x1/is.svg
// module chunks = styles